var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{staticClass:"ma-0",class:_vm.grow ? 'up' : 'down',attrs:{"persistent":""},model:{value:(_vm.enable),callback:function ($$v) {_vm.enable=$$v},expression:"enable"}},[_c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_vm._t("left"),_vm._t("center"),_vm._t("right")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }